import { Injectable } from '@angular/core';
import { HttpInterceptor, HttpEvent, HttpHandler, HttpRequest, HttpErrorResponse, HttpResponse } from '@angular/common/http';
import { iif, Observable, of, throwError, timer } from 'rxjs';
import { retryWhen, mergeMap, tap, concatMap, delay, retry, delayWhen, scan  } from 'rxjs/operators';
import { OnboardErrorHandler } from '../error-handler/error-handler.service';
import { ActivatedRoute, Router } from '@angular/router';
import { SharedService } from '../shared/shared.service';
import { UtilsService } from 'src/app/utils/utils.service';
// import { UtilsService } from 'src/app/utils/utils.service';
// SharedService
/** retry conuter */
export const retryCount = 2;
/** retry waiting time */
export const retryWaitMilliSeconds = 1000;
/**
 * Rest Interceptor
 */
@Injectable()
export class RestInterceptor implements HttpInterceptor {
  /** store session storage value */
  private storage;
  /**
   * initial component load
   * @param errorHandler error handler
   * @param route  routing path
   * @param shared shared service value
   */
  constructor(private errorHandler: OnboardErrorHandler, private route: Router, private shared: SharedService) {
    // this.storage = window.sessionStorage || window.localStorage;
    this.storage = window.sessionStorage;
    console.log('inside interceptor');

    
  }

  
/**
 * passing authorization token base on url
 * @param req  passing API request response
 * @param next API error handling
 * @returns  handled message
 */
  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    let requestCloned: HttpRequest<any> | null = null;
    const requestFrom = this.storage.getItem('requestFrom') || null;
    const invid = this.storage.getItem('invid') || null;
    if(requestFrom === "modification" && invid) {
      req.headers.append('investorId', UtilsService.decryptText(invid))
    }

    if (req.headers && req.headers.keys().length) {
      requestCloned = <HttpRequest<any>>req.clone({
        setHeaders: {
          ips: this.storage.getItem('address') || '',
          fingerprint: this.storage.getItem('fingerprint') || '',
          lang: this.storage.getItem('lang') || 'en',
          authorization: this.storage.getItem('access_token') || sessionStorage.getItem('accessToken') || '',
          // requestFrom: ((this.storage.getItem('requestFrom') || '') == 'onboarding' ? 'onboarding': (this.storage.getItem('requestFrom') || '') == 'modification'? 'modification': (this.storage.getItem('requestFrom') || '') == 'raiseIssue'? 'raiseIssue' : '') 
          requestFrom:location.pathname.indexOf('respond-issue') > -1 ? 'raiseIssue' : this.storage.getItem('requestFrom'),
          requestSource:location.pathname.indexOf('respond-issue') > -1 ? 'raiseIssue' : location.href.indexOf('account-closure') > -1 ? 'accountClosure' : location.pathname.indexOf('modification/trading/client-login')> -1 ? 'clientModification'  :this.storage.getItem('requestSource'),
          businessUnit: this.storage.getItem('businessUnit') || ''
        }
        
      })
      
    }

    return next.handle(requestCloned || req).pipe(
      retryWhen(error => 
        error.pipe(
          concatMap((error, count) => {
            if (count <= retryCount && (error.status == 401)) {
              this.shared.tokenFailure.next(requestFrom);
              // this.utils.showSessionExpiredPopup();
              return throwError(error);
              // return of(error);
            }
            else if(count < retryCount && (error.status != 422 && error.status != 404)){
              // console.log('interror',error);
              if(error && error.url && error.url.indexOf('preview/document') > -1){
                return throwError(error);
              }else{
                return of(error);
              }
            }
            // else if(count <= retryCount && (error.status == 422 || error.status == 400)){
            //   return throwError(error);
            // }
            else{
              return throwError(error);
            }
            // return throwError(error);
          }),
          delay(retryWaitMilliSeconds)
        )
      )
    )

  }
}


